


export type EnumKey = string;
export type EnumPromise = Promise<any[]>;
export const ENUM_HASH_KEY = (lang: string) => `enum_hash_${lang}`;
export interface EnumContextType {
    getEnum: (key: string, url?: string) => Promise<any[]>;
    clearEnum: (key?: string) => Promise<void>;
    updateId: number;
}